import { Link } from 'react-router-dom';

import { AppHeader, HeaderUserActions } from '@/shared/components/layout';
import { PATHS } from '@/shared/constants/app/routes.constant.ts';

/**
 * 품셈해설 **관리** 헤더.
 *
 * 열람 헤더(`PumsemHeader`)와 파일을 나눈 이유: 겹치는 게 로고와 사용자 영역뿐이다.
 * 관리 화면에는 검색창도, 개정판 셀렉트도, 결과 목록 토글도 없다. 하나의
 * 컴포넌트에 `variant` 로 몰면 쓰지 않는 prop 이 절반이고, 그 절반이 나중에
 * "관리 화면에서도 검색이 되나?" 하는 오해를 만든다.
 *
 * 대신 껍데기(`AppHeader`)와 full-width 규약은 그대로 공유한다 — 관리로
 * 들어갔다 나올 때 로고와 아바타가 같은 자리에 있어야 한다.
 * 좌측 존 폭은 주지 않는다: 관리 화면에는 정렬할 사이드바가 없다.
 */
export function PumsemManageHeader() {
  return (
    <AppHeader
      position="sticky"
      width="full"
      logoTo={PATHS.PUMSEM}
      start={
        <span className="flex items-center gap-2">
          <Link
            to={PATHS.PUMSEM_MANAGE}
            className="shrink-0 text-[18px] font-semibold text-neutral-950/70 transition-colors hover:text-neutral-950 dark:text-white/70 dark:hover:text-white"
          >
            품셈해설
          </Link>
          <span className="rounded-md bg-brand-50 px-2 py-0.5 text-[12px] font-bold text-brand-700 dark:bg-brand-500/15 dark:text-brand-300">
            관리
          </span>
        </span>
      }
      end={
        <>
          <Link
            to={PATHS.PUMSEM}
            className="hidden rounded-lg border border-neutral-200 px-3 py-1.5 text-[13.5px] font-bold text-neutral-700 transition-colors hover:bg-neutral-50 sm:inline-block dark:border-white/12 dark:text-neutral-200 dark:hover:bg-white/5"
          >
            공개 화면
          </Link>
          <HeaderUserActions showNotifications={false} />
        </>
      }
    />
  );
}
